export default {"src":"/_next/static/media/Candle-transaction-chart.6a6c6131.svg","height":185,"width":534};